import autobind from 'core-decorators/lib/autobind';
import { VODCSSModules } from 'shared/utils/wix-connect';

import ThumbnailOverlayStrip from 'widget/components/videos-list/strip/thumbnail-overlay/thumbnail-overlay';
import { SimpleVideoThumbnail } from 'widget/components/thumbnail/simple';

import styles from './video-list-item.styl';


@VODCSSModules(styles)
export default class VideoListItem extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    channelData: React.PropTypes.object,
    videoItem: React.PropTypes.object,

    width: React.PropTypes.number,
    height: React.PropTypes.number,

    onPlayRequest: React.PropTypes.func,
    onClick: React.PropTypes.func,
  };

  @autobind
  handleClick() {
    const { videoItem, onClick } = this.props;
    onClick(videoItem);
  }

  @autobind
  handlePlayClick() {
    const { videoItem, onPlayRequest } = this.props;
    onPlayRequest(videoItem);
  }

  render() {
    const {
      channelData,
      videoItem,
      width,
      height,
      appSettings,
    } = this.props;

    return (
      <div styleName="container"
           onClick={this.handleClick}
           style={{ height, width }}
           data-hook="videoListThumbWrapper">
        <SimpleVideoThumbnail video={videoItem}
                              width={width}
                              height={height} />
        <ThumbnailOverlayStrip styleName="overlay"
                               channelData={channelData}
                               videoItem={videoItem}
                               width={width}
                               appSettings={appSettings}
                               playSelectedVideo={this.handlePlayClick} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/strip/components/videos/video-list-item/video-list-item.js